import * as React from 'react';
import { useStoreActions } from 'easy-peasy';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Get } from '../services/http';

export default function CampaignsPage() {
    const [campaigns, setCampaigns] = React.useState(null);
    const getCampaignsList = async () => {
        const serverUserData = await Get('/api/donation/GetCampaignsList', '');
        if (serverUserData.result) {
            serverUserData.campaigns.map((item) => {
                const percent = (item.sumDonated / item.donatedGoal) * 100;
                item.percent = percent ? percent.toString() + '%' : '0%';
                return item;
            });
            setCampaigns(serverUserData.campaigns);
        }
        console.log('campaings: ', serverUserData.campaigns);
    };

    React.useEffect(() => {
        getCampaignsList();
    }, []);

    return (
        <main className="main">
            <div className="main__body">
                <div className="container">
                    <div className="main__head">
                        <h1 className="main__title">
                            <span>CAMPAIGNS</span>
                        </h1>
                    </div>
                    <div className="campaigns">
                        {campaigns?.map((item) => (
                            <div className="campaigns__item">
                                <a href={'/campaign/' + item.id} className="item-campaign">
                                    <div className="item-campaign__img"><img src={item.mainImage} alt="" /></div>
                                    <div className="item-campaign__body">
                                        <div className="item-campaign__title">{item.name}</div>
                                        <div className="item-campaign__text">{item.shortText}</div>
                                        <div className="item-campaign__progress progress">
                                            <div className="progress__track" style={{ width: item.percent }}></div>
                                        </div>
                                        <div className="item-campaign__icons-grid icons-grid">

                                            <div className="icons-grid__item">

                                                <div className="icons-grid__title">Fund Raised: <span>${item.sumDonated.toFixed(2)}</span></div>
                                            </div>
                                            <div className="icons-grid__item">

                                                <div className="icons-grid__title">Raised Percent: <span>{parseFloat(item.percent).toFixed(2) + '%'}</span></div>
                                            </div>
                                            <div className="icons-grid__item">

                                                <div className="icons-grid__title">Supporters: <span>{item.supportersNum}</span></div>
                                            </div>

                                        </div>
                                    </div>
                                </a>
                            </div>
                        ))}
                        <div className="main__button text-center">
                            <a href="#" className="btn btn--info">Load More</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
